(function ($) {
    /* eslint-disable */
    /* global Swiper */

    var duration = 7;
    var $slideCurrent = $('.slide-current');
    var $slideNext = $('.slide-next');

    var heroSlider = new Swiper('.swiper-hero', {
        breakpoints: {
            992: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            }
        },
        effect: 'fade',
        autoplay: {
            delay: duration * 1000,
        },
        simulateTouch: false,
        allowTouchMove: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: false,
        },
        on: {
            init: function (e) {
                var swiper = this;
                setSlideIndex(swiper);
            },
            slideChange: function (e) {
                var swiper = this;
                setSlideIndex(swiper);
            }
        }
    });


    function slideIndex(number) {
        return '<span>'+ 0 + + number + '</span>'
    }

    function setSlideIndex(swiper) {
        var length = $(swiper.slides).length;
        var index = swiper.realIndex + 1;
        var next = index + 1 > length ? 1 : index + 1;
        var prev = index - 1 < 0 ? length : index;

        $slideCurrent.html(slideIndex(prev));
        $slideNext.html(slideIndex(next))
    }
})( jQuery );

